module.exports = __webpack_public_path__ + "img/nuclei-07.e896b3a7.png";